import axios from "axios";
import { store } from "../redux/store";
import {
  addproviders,
  addprovidersInReview,
  adduserData,
  addviewProviderInReview,
} from "../redux/mainSlice";
import { Timeframe } from "../../types/type";
// const baseUrl = "https://pureworker-3482.onrender.com/api";
// https://pureworker.onrender.com
const baseUrl = process.env.REACT_APP_BASE_URL;

export const getUser = async (param: any) => {
  //   const AuthToken = await localStorage.getItem('AuthToken');
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getUser func started");

  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/admin/me`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("USER:", response?.data);
      store.dispatch(adduserData(response?.data.user));
    }
    console.log("res", response);
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};
export const getStats = async () => {
  //   const AuthToken = await localStorage.getItem('AuthToken');
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getStats func started");

  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/admin/order-stats`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("USER:", response?.data);
      store.dispatch(adduserData(response?.data.user));
    }
    console.log("res", response);
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};
export const getUserStats = async () => {
  //   const AuthToken = await localStorage.getItem('AuthToken');
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getStats func started");

  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/admin/user-stats-by-type`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("USER:", response?.data);
      // store.dispatch(adduserData(response?.data.user));
    }
    console.log("res", response);
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const getCustomers = async (param: any) => {
  //   const AuthToken = await localStorage.getItem('AuthToken');
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getCustomers func started");

  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/admin/customers`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
    }
    //   console.log("res", response);
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const getServices = async (param: any) => {
  //   const AuthToken = await localStorage.getItem('AuthToken');
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getServices func started");
  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/admin/services`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};
export const getCategories = async (param: any) => {
  //  const AuthToken = await localStorage.getItem('AuthToken');
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getCustomer func started");
  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/admin/categories`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};
export const getTransactions = async (param: any) => {
  //  const AuthToken = await localStorage.getItem('AuthToken');
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getTransactions func started");
  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/admin/transactions`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};
export const getTransactionsById = async (param: any) => {
  //  const AuthToken = await localStorage.getItem('AuthToken');
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getTransactionsBYID func started");
  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/transaction/get-user-transactions/${param}`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};
export const getProviders = async (param: any) => {
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getProviders func started");
  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/admin/providers`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
      store.dispatch(addproviders(response?.data?.providers));
    }
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const getReferrals = async (param?: Timeframe) => {
  //  const AuthToken = await localStorage.getItem('AuthToken');
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getProviders func started");
  const formatDate = (date: Date) => {
    const dateObj = new Date(date);

    const year = dateObj.getFullYear();
    const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    const day = ("0" + dateObj.getDate()).slice(-2);

    const formattedDate = `${year}-${month}-${day}`;

    return formattedDate;
  };

  const urlParams =
    param?.endDate && param?.startDate
      ? `?start=${formatDate(param.startDate)}&end=${formatDate(param.endDate)}`
      : "";

  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/admin/referrals` + urlParams,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};
export const getLessThanTwoStars = async (param: any) => {
  const AuthToken = await localStorage.getItem("AuthToken");
  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/admin/orders-less-than-two-rating`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};
export const getOrders = async (param: any) => {
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getOrders func started");
  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/admin/orders`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const getNewOrders = async (param: any) => {
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getOrders func started");
  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/admin/customer-first-orders`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const getPendingIDCheck = async () => {
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getOrders func started");
  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/admin/pending-verifications`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};
export const getPendingIDCheckByID = async (id: string) => {
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getOrders func started");
  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/admin/pending-verifications?id=${id}`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};
export const getUserVerificationData = (userId: string) => axios.get(
  `${baseUrl}/admin/verification/user/${encodeURIComponent(userId)}`,
  { headers: { Authorization: `Bearer ${localStorage.getItem("AuthToken")}` } }
);

export const approvePendingIDCheck = async (id: any) => {
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getOrders func started");
  try {
    const response = await axios({
      method: "post",
      url: `${baseUrl}/admin/approve-verifications/${id}`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
      data: {
        status: "approved",
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const getUserStatsByType = async (param: any) => {
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getUserStatsByType func started");
  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/admin/user-stats-by-type`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};
export const getUserStatsByDate = async (year: string) => {
  //  const AuthToken = await localStorage.getItem('AuthToken');
  const AuthToken = localStorage.getItem("AuthToken");
  console.log("getUserStatsByDate func started");
  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/admin/user-stats-by-date/?year=${year}`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};
export const getOrderStats = async (param: any) => {
  //  const AuthToken = await localStorage.getItem('AuthToken');
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getOrderStats func started");
  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/admin/order-stats`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};
export const getOrderServiceStats = async () => {
  //  const AuthToken = await localStorage.getItem('AuthToken');
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getOrderStats func started");
  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/admin/order-service-stats`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const getAmountStats = async () => {
  //  const AuthToken = await localStorage.getItem('AuthToken');
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getOrderStats func started");
  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/admin/amount-stats`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const getNotifications = async (param: any) => {
  //  const AuthToken = await localStorage.getItem('AuthToken');
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getNotifications func started");
  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/get-all-notifications`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const getFAQ = async (param: any) => {
  //  const AuthToken = await localStorage.getItem('AuthToken');
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getNotifications func started");
  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/get-faq`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

/** Exchange the MFA challenge cookie for a session. */
export const verifyMfaCode = async (code: string) => {
  try {
    return await axios({
      method: "post",
      url: `${baseUrl}/admin/mfa/verify`,
      data: { code },
    });
  } catch (error: any) {
    return { status: 401, error: error?.response?.data };
  }
};

/** Step one of enrolment: a secret and the otpauth URI to render as a QR. */
export const beginMfaEnrolment = async () => {
  try {
    return await axios({ method: "post", url: `${baseUrl}/admin/mfa/begin` });
  } catch (error: any) {
    return { status: 400, error: error?.response?.data };
  }
};

/** Step two: proving a code turns it on and returns the backup codes, once. */
export const completeMfaEnrolment = async (code: string) => {
  try {
    return await axios({
      method: "post",
      url: `${baseUrl}/admin/mfa/complete`,
      data: { code },
    });
  } catch (error: any) {
    return { status: 400, error: error?.response?.data };
  }
};

export const disableMfa = async (code: string) => {
  try {
    return await axios({
      method: "post",
      url: `${baseUrl}/admin/mfa/disable`,
      data: { code },
    });
  } catch (error: any) {
    return { status: 400, error: error?.response?.data };
  }
};

export const signIn = async (param: any) => {
  console.log("signIn func started", param, "here");

  try {
    const response = await axios({
      method: "post",
      url: `${baseUrl}/admin/log-in`,
      data: param,
    });
    const storeTokenData = async (res: any) => {
      try {
        // The API no longer returns a token: auth is the httpOnly cookie it set
        // on this response, which JavaScript cannot read. Storing anything here
        // is what the migration removed, so this clears any value left over
        // from a session that predates it.
        localStorage.removeItem("AuthToken");
        await localStorage.setItem("Role", res?.data?.user?.accountType);
        // A marker, NOT a credential: it says "the UI believes there is a
        // session", so a page refresh does not bounce you to login while the
        // cookie is still perfectly valid. It grants nothing on its own — every
        // request is authorised by the cookie, and a stale marker just means one
        // 401 and a redirect.
        localStorage.setItem("pw_admin_session", "1");
      } catch (e) {
        // saving error
        console.log("Error Saving Token data.");
      }
    };
    // A pending second factor is NOT a session. The API returns 200 with
    // status "mfa_required" and deliberately sets no session cookie, so the
    // marker must not be written either: ProtectedRoute trusts it, and
    // writing it here would let a refresh walk past the code screen.
    if (response?.data?.status !== "mfa_required") {
      await storeTokenData(response);
    }

    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    console.log(response?.data);
    return response;
  } catch (error: any) {
    console.log(error);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const addAgent = async (param: any) => {
  console.log("addAgent func started", param);
  const AuthToken = await localStorage.getItem("AuthToken");

  try {
    const response = await axios({
      method: "post",
      url: `${baseUrl}/admin/add-agent`,
      data: param,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    console.log(response?.data);
    return response;
  } catch (error: any) {
    console.log(error);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};
export const editAgent = async (id: any, body: any) => {
  console.log("edit func started", id);
  const AuthToken = await localStorage.getItem("AuthToken");
  try {
    const response = await axios({
      method: "patch",
      url: `${baseUrl}/admin/update-admin-account/${id}`,
      data: body,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    console.log(response?.data);
    return response;
  } catch (error: any) {
    console.log(error);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};
export const deleteAgent = async (id: any) => {
  console.log("edit func started", id);
  const AuthToken = await localStorage.getItem("AuthToken");

  try {
    const response = await axios({
      method: "delete",
      url: `${baseUrl}/admin/delete-admin-account/${id}`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    console.log(response?.data);
    return response;
  } catch (error: any) {
    console.log(error);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};
export const deletePromo = async (id: any) => {
  console.log("edit func started", id);
  const AuthToken = await localStorage.getItem("AuthToken");

  try {
    const response = await axios({
      method: "delete",
      url: `${baseUrl}/admin/promo/${id}`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    console.log(response?.data);
    return response;
  } catch (error: any) {
    console.log(error);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const getCustomersOrders = async (param: any) => {
  //   const AuthToken = await localStorage.getItem('AuthToken');
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getCustomersOrders func started");

  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/admin/customer-orders/${param}`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    //   console.log("res", response);
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};
export const getProviderOrders = async (param: any) => {
  //   const AuthToken = await localStorage.getItem('AuthToken');
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getCustomersOrders func started");

  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/admin/provider-orders/${param}`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("getProviderOrders here and there:", response?.data);
    }
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const getAgents = async (param: any) => {
  //   const AuthToken = await localStorage.getItem('AuthToken');
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getMessages func started");

  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/admin/all-admins`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    //   console.log("res", response);
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const getChat = async (param: any) => {
  //   const AuthToken = await localStorage.getItem('AuthToken');
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getChat func started");

  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/chats-admin`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    //   console.log("res", response);
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const getMessages = async (param: any) => {
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getMessages func started");
  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/messages-admin/${param}`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    //   console.log("res", response);
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const getSupportUser = async (param: any) => {
  //   const AuthToken = await localStorage.getItem('AuthToken');
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getSupportUser func started");

  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/get-support-user`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    //   console.log("res", response);
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const sendPushtoUserbyID = async (param: any) => {
  console.log("sendPushtoUserbyID func started", param);
  const AuthToken = await localStorage.getItem("AuthToken");
  try {
    const response = await axios({
      method: "post",
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
      // url: `${baseUrl}/admin/sendPush/${param}`,
      url: `${baseUrl}/admin/send-notification`,
      data: param,
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    console.log(response?.data);
    return response;
  } catch (error: any) {
    console.log(error);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const addFaq = async (param: any) => {
  console.log("addFaq func started", param);
  const AuthToken = await localStorage.getItem("AuthToken");
  try {
    const response = await axios({
      method: "post",
      url: `${baseUrl}/create-faq`,
      data: param,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    console.log(response?.data);
    return response;
  } catch (error: any) {
    console.log(error);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const getAllCategories = async (param: any) => {
  //   const AuthToken = await localStorage.getItem('AuthToken');
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getAllCategories func started");

  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/service/get-all-categories`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    //   console.log("res", response);
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const addServices = async (param: any) => {
  console.log("addServices func started", param);
  const AuthToken = await localStorage.getItem("AuthToken");
  try {
    const response = await axios({
      method: "post",
      url: `${baseUrl}/service/create-service`,
      data: param,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    console.log(response?.data);
    return response;
  } catch (error: any) {
    console.log(error);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const addCategory = async (param: any) => {
  console.log("addCategory func started", param);
  const AuthToken = await localStorage.getItem("AuthToken");
  try {
    const response = await axios({
      method: "post",
      url: `${baseUrl}/service/create-category`,
      data: param,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    console.log(response?.data);
    return response;
  } catch (error: any) {
    console.log(error);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const removeFaq = async (param: any) => {
  console.log("removeFaq func started", param);
  const AuthToken = await localStorage.getItem("AuthToken");
  try {
    const response = await axios({
      method: "delete",
      url: `${baseUrl}/delete-faq/${param}`,
      data: param,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    console.log(response?.data);
    return response;
  } catch (error: any) {
    console.log(error);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const addSettingsContent = async (param: any) => {
  console.log("addSettingsContent func started", param);
  const AuthToken = await localStorage.getItem("AuthToken");
  try {
    const response = await axios({
      method: "post",
      url: `${baseUrl}/add-content`,
      data: param,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    console.log(response?.data);
    return response;
  } catch (error: any) {
    console.log(error);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const getSettingsContentByTitle = async (param: any) => {
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getSettingsContentByTitle func started");

  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/get-content/${param}`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    //   console.log("res", response);
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const getInReviewProviders = async (param: any) => {
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getInReviewProviders func started");

  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/admin/providers?isVerified=review`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
      store.dispatch(addprovidersInReview(response?.data?.providers));
    }
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const deleteContent = async (param: any) => {
  console.log("deleteContent func started", param);
  const AuthToken = await localStorage.getItem("AuthToken");
  try {
    const response = await axios({
      method: "delete",
      url: `${baseUrl}/delete-content/${param}`,
      // data: param,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    console.log(response?.data);
    return response;
  } catch (error: any) {
    console.log(error);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const deleteCategories = async (param: any) => {
  console.log("deleteCategories func started", param);
  const AuthToken = await localStorage.getItem("AuthToken");
  try {
    const response = await axios({
      method: "post",
      url: `${baseUrl}/delete-content/${param}`,
      // data: param,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    console.log(response?.data);
    return response;
  } catch (error: any) {
    console.log(error);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const getAllProviderData_ = async (param: any) => {
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getAllProviderData func started", "id:", param);
  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/provider/get-profile/${param}`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
      store.dispatch(addviewProviderInReview(response?.data?.profile));
    }
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const approveProvider = async (param: any) => {
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("approveProvider func started", "id:", param);
  try {
    const response = await axios({
      method: "patch",
      url: `${baseUrl}/provider/approve-profile/${param.id}/${param.status}`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
      data: {
        reason: param.reason,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("approveProvider:", response?.data);
    }
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const alterUserBalance = async (body: any) => {
  console.log("alterUserBalance func started", body);
  const AuthToken = await localStorage.getItem("AuthToken");

  try {
    const response = await axios({
      method: "post",
      url: `${baseUrl}/admin/alter-wallet`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
      data: body,
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    console.log(response?.data);
    return response;
  } catch (error: any) {
    console.log(error);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};
export const verifyIdentityDetails = async (param: any) => {
  console.log("verifyIdentity func started", param);
  const AuthToken = await localStorage.getItem("AuthToken");

  try {
    const response = await axios({
      method: "patch",
      url: `${baseUrl}/admin/verify-identity-detail/${param}`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
      data: param,
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    console.log(response?.data);
    return response;
  } catch (error: any) {
    console.log(error);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};
export const verifyIdentity = async (body: any) => {
  const AuthToken = await localStorage.getItem("AuthToken");

  try {
    const response = await axios({
      method: "post",
      url: `${baseUrl}/admin/identity-detail`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
      data: body,
    });
    return response;
  } catch (error: any) {
    return {
      status: error?.response?.status || 0,
      error: error?.response?.data,
    };
  }
};

export const fetchOrderDetails = async (body: any) => {
  console.log("fetchOrderDetails func started", body);
  const AuthToken = await localStorage.getItem("AuthToken");

  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/ordern/order/${body}`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    return response;
  } catch (error: any) {
    console.log(error);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const getBlogs = async (param: any) => {
  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/get-blogs`,
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    return response;
  } catch (error: any) {
    console.log(error);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const getBlog = async (param: any) => {
  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/get-blog/${param}`,
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    return response;
  } catch (error: any) {
    console.log(error);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const addBlog = async (param: any) => {
  const AuthToken = await localStorage.getItem("AuthToken");
  try {
    const response = await axios({
      method: "post",
      url: `${baseUrl}/create-blog`,
      data: param,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    console.log(response?.data);
    return response;
  } catch (error: any) {
    console.log(error);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const deleteBlog = async (param: any) => {
  const AuthToken = localStorage.getItem("AuthToken");
  try {
    const response = await axios({
      method: "delete",
      url: `${baseUrl}/delete-blog/${param}`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    console.log(response);
    return response;
  } catch (error: any) {
    console.log(error);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const editBlog = async (id: any, body: any) => {
  const AuthToken = localStorage.getItem("AuthToken");
  try {
    const response = await axios({
      method: "patch",
      url: `${baseUrl}/update-blog/${id}`,
      data: body,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    console.log(response?.data);
    return response;
  } catch (error: any) {
    console.log(error);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const downloadMailingList = async (id: any, body: any) => {
  const AuthToken = localStorage.getItem("AuthToken");
  try {
    const response = await axios({
      method: "get",
      url: `https://api.pureworker.com/api/mailing-lists`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    console.log(response?.data);
    return response;
  } catch (error: any) {
    console.log(error);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const downloadWaitingList = async (id: any, body: any) => {
  const AuthToken = localStorage.getItem("AuthToken");
  try {
    const response = await axios({
      method: "get",
      url: `https://api.pureworker.com/api/mailing-lists`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    console.log(response?.data);
    return response;
  } catch (error: any) {
    console.log(error);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const markAsRead = async (messageId: string) => {
  const AuthToken = localStorage.getItem("AuthToken");
  // unread-chats
  await axios.patch(
    `${baseUrl}/mark-messages-as-read`,
    { messageIDs: [messageId] },
    {
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    }
  );
};

export const getAllTransactons = async (param: any) => {
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getAllTransactons func started");

  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/admin/transactions`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    //   console.log("res", response);
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const getAllWithdrawals = async (param: any) => {
  const AuthToken = await localStorage.getItem("AuthToken");
  // console.log("getAllTransactons func started");

  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/admin/withdrawals?status=pending`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("withdrawal response data:", response?.data);
    }
    //   console.log("res", response);
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const approveWithdrawal = async (id: any) => {
  const AuthToken = await localStorage.getItem("AuthToken");
  // console.log("getAllTransactons func started");

  try {
    const response = await axios({
      method: "post",
      url: `${baseUrl}/admin/approve-withdrawal/${id}`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
      data: {
        status: "approved",
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("withdrawal response data:", response?.data);
    }
    //   console.log("res", response);
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const declineWithdrawal = async (id: string, note: string) => {
  const AuthToken = await localStorage.getItem("AuthToken");
  // console.log("getAllTransactons func started");

  try {
    const response = await axios({
      method: "post",
      url: `${baseUrl}/admin/approve-withdrawal/${id}`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
      data: {
        status: "rejected",
        note: note,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("withdrawal response data:", response?.data);
    }
    //   console.log("res", response);
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const getReferralsByID = async (param: any) => {
  const AuthToken = await localStorage.getItem("AuthToken");
  console.log("getReferralsByID func started");

  try {
    const response = await axios({
      method: "get",
      url: `${baseUrl}/admin//referrals/${param}`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    return response;
  } catch (error: any) {
    console.log(error, error?.response?.data);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};

export const changeReferralCode = async (param: any) => {
  console.log("changeReferralCode func started", param);
  const AuthToken = await localStorage.getItem("AuthToken");

  try {
    const response = await axios({
      method: "post",
      url: `${baseUrl}/admin/change-referral-code`,
      data: param,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });
    if (response.status === 201 || response.status === 200) {
      console.log("response data:", response?.data);
    }
    console.log(response?.data);
    return response;
  } catch (error: any) {
    console.log(error);
    return {
      status: 400,
      err: error,
      error: error?.response?.data,
    };
  }
};


/** End the session on the SERVER, which is the only place that can clear an
 *  httpOnly cookie. Clearing localStorage alone used to be "logging out"; with
 *  the cookie it would leave a fully valid session in the browser while the
 *  panel showed a login screen. */
export const adminLogout = async () => {
  try {
    localStorage.removeItem("pw_admin_session");
    return await axios({ method: "post", url: `${baseUrl}/admin/log-out` });
  } catch (error: any) {
    return { status: 400, err: error };
  }
};
